module.exports = __webpack_public_path__ + "img/douyin.87c6a398.png";